(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/models/game-structure-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/models/game-structure-abtest.js');
'use strict';

const games = [{
  id: 1,
  value: 'all',
  label: 'Alla spel'
}, {
  id: 2,
  value: 'casino',
  label: 'Casino och Momang'
}, {
  id: 3,
  value: 'oddset',
  label: 'Oddset'
}, {
  id: 4,
  value: 'poker',
  label: 'Poker'
}, {
  id: 5,
  value: 'bingo',
  label: 'Bingo'
}, {
  id: 6,
  value: 'tipsspel',
  label: 'Tipsspel*'
}];
const allGamesAbTest = {
  games
};
svs.selfExclusion.allGamesAbTest = allGamesAbTest;

 })(window);